/**
* Created by lobin on 2020/6/18.
*/
<template>
  <a-row :gutter="16">
    <a-col :span="5">
      <a-card :body-style="{padding: '16px 10px'}" :bordered="false" class="cabinet">
        <station-select @select="stationSelect" />
      </a-card>
    </a-col>
    <a-col :span="19">
      <a-card :body-style="{padding: '24px', minHieght: '600px'}" :bordered="false" class="cabinet">
        <div v-if="stationId">
          <a-row :gutter="16">
            <div style="text-align: right">
              <h3 style="float: left">格子使用率及占用率</h3>
              <a-space>
                <a-range-picker v-model="range" @change="dateChange" valueFormat="YYYY-MM-DD" />
              </a-space>
            </div>
            <a-divider />
            <a-col :span="24" class="chart">
              <!-- <h4>月报数据</h4> -->
              <a-spin :spinning="listloading" :delay="300">
                <e-chart :option="chartOneOptions" style="height: 320px;"></e-chart>
                <e-chart :option="chartTowOptions" style="height: 320px;margin-top:20px"></e-chart>
              </a-spin>
            </a-col>
          </a-row>
        </div>
        <a-empty v-else description="请选择站点" />
      </a-card>
    </a-col>

  </a-row>
</template>

<script type="text/babel">
import { mapActions } from 'vuex';
import { cabUsage } from '@/api/analysis';
import moment from 'moment';
import VChart from 'vue-echarts';
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { ScatterChart, LineChart } from 'echarts/charts';
import { UniversalTransition } from 'echarts/features';
import {
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  BrushComponent,
  MarkLineComponent,
  MarkAreaComponent,
  MarkPointComponent,
} from 'echarts/components';

use([
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  BrushComponent,
  MarkLineComponent,
  MarkAreaComponent,
  MarkPointComponent,
  ScatterChart,
  LineChart,
  CanvasRenderer,
  UniversalTransition,
]);
export default {
  components: {
    EChart: VChart,
  },
  data() {
    return {
      listloading: false,
      stationId: '',
      height: 280,
      style: { stroke: '#fff', lineWidth: 1 },
      dateRange: [],
      range: [
        moment().subtract(1, 'day').format('YYYY-MM-DD'),
        moment().format('YYYY-MM-DD'),
      ],
      chartOneOptions: {
        title: {
          text: '格子使用率',
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            animation: false,
            label: {
              backgroundColor: '#ccc',
              borderColor: '#aaa',
              borderWidth: 1,
              shadowBlur: 0,
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              color: '#222',
            },
          },
          formatter(params) {
            let relVal = params[0].name;
            for (let i = 0; i < params.length; i++) {
              relVal += `<br/>${params[i].seriesName} : ${params[i].value} %`;
            }
            return relVal;
          },
        },
        legend: {
          data: ['迷你', '小', '中', '大', '总体'],
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        // toolbox: {
        //   feature: {
        //     saveAsImage: {}
        //   }
        // },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: [],
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter(val) {
              return `${val}%`;
            },
          },
        },
        series: [
          {
            name: '迷你',
            type: 'line',
            showSymbol: false,
            data: [],
          },
          {
            name: '小',
            type: 'line',
            showSymbol: false,
            data: [],
          },
          {
            name: '中',
            type: 'line',
            showSymbol: false,
            data: [],
          },
          {
            name: '大',
            type: 'line',
            showSymbol: false,
            data: [],
          },
          {
            name: '总体',
            type: 'line',
            showSymbol: false,
            data: [],
          },
        ],
      },
      chartTowOptions: {
        title: {
          text: '格子占用率',
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            animation: false,
            label: {
              backgroundColor: '#ccc',
              borderColor: '#aaa',
              borderWidth: 1,
              shadowBlur: 0,
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              color: '#222',
            },
          },
          formatter(params) {
            let relVal = params[0].name;
            for (let i = 0; i < params.length; i++) {
              relVal += `<br/>${params[i].seriesName} : ${params[i].value} %`;
            }
            return relVal;
          },
        },
        legend: {
          data: ['迷你', '小', '中', '大'],
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        // toolbox: {
        //   feature: {
        //     saveAsImage: {}
        //   }
        // },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: [],
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter(val) {
              return `${val}%`;
            },
          },
        },
        series: [
          {
            name: '迷你',
            type: 'line',
            showSymbol: false,
            data: [],
          },
          {
            name: '小',
            type: 'line',
            showSymbol: false,
            data: [],
          },
          {
            name: '中',
            type: 'line',
            showSymbol: false,
            data: [],
          },
          {
            name: '大',
            type: 'line',
            showSymbol: false,
            data: [],
          },
        ],
      },
    };
  },
  methods: {
    ...mapActions(['getStationList']),
    handleChange(val) {
      this.year = val;
      this.getList();
    },
    stationSelect(stationId) {
      this.stationId = stationId;
      this.getList();
    },
    dateChange() {
      this.getList();
    },
    async getList() {
      this.listloading = true;
      const { stationId } = this;
      const { data } = await cabUsage({
        station: stationId,
        start: this.range[0],
        end: this.range[1],
      });
      this.setDate(data);
      this.listloading = false;
    },
    setDate(sourceData) {
      console.log(sourceData);
      this.chartOneOptions.xAxis.data = sourceData.xAxis;
      this.chartTowOptions.xAxis.data = sourceData.xAxis;

      this.chartOneOptions.series[0].data = sourceData.usage.mini;
      this.chartOneOptions.series[1].data = sourceData.usage.small;
      this.chartOneOptions.series[2].data = sourceData.usage.middle;
      this.chartOneOptions.series[3].data = sourceData.usage.big;
      this.chartOneOptions.series[4].data = sourceData.usage.total;

      this.chartTowOptions.series[0].data = sourceData.rate.mini;
      this.chartTowOptions.series[1].data = sourceData.rate.small;
      this.chartTowOptions.series[2].data = sourceData.rate.middle;
      this.chartTowOptions.series[3].data = sourceData.rate.big;
    },
  },
};

</script>

<style lang="less" rel="stylesheet/less">
.cabinet {
  .ant-avatar{
    font-size: 20px;
  }
  &-item{
    .ant-avatar{
      background: rgba(0,0,0,.09);
    }
    &.processing{
        .ant-avatar{
          background: rgb(135, 208, 104);
        }
    }
    .warning{
      .ant-avatar{
        background: #faad14;
      }
    }
    &.error{
      .ant-avatar{
        background: #f5222d;
      }
    }
  }
}
.list-content-item {
  color: rgba(0, 0, 0, .45);
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
  margin-left: 40px;
  span {
    line-height: 20px;
  }
  p {
    margin-top: 4px;
    margin-bottom: 0;
    line-height: 22px;
  }
}
</style>
